import React from 'react'

import VScroll from "../../../../scrolling/custom-v-scroll/v-scroll"
import {COVER_SELECTOR_MENU_HEIGHT} from "../../selector-popover"
import {Cover} from "../../../../../model2/task/properties/cover"
import getCoverGalleryItems from "./gallery-items"

type Props = {
    onCoverSelected: {(cover:Cover):void}
}

const debug = false
// const debug = "CoverSelectorGallery"

export default function CoverSelectorGallery (props:Props) {

    const styles = {
        height: `calc(100% - ${COVER_SELECTOR_MENU_HEIGHT}px)`
    }

    const galleryItems = getCoverGalleryItems()

    debug && console.log(debug, 'render', galleryItems)

    return (
        <div className="cover-gallery" style={styles}>
            <VScroll containerClass="p-l-15 p-t-10 p-r-15 p-b-20">
                {_.map(galleryItems, (group:any, key:number) =>
                    <div key={key} className="flex-column-left-center m-b-10">
                        <div className="flex-row-left-center ui5-title-tiny h-30 m-b-10">{group.title}</div>
                        <div className="flex-row-left-center fl-wrap">
                            {_.map(group.items, item =>
                                <div key        = {item.id}
                                     className  = "cover-item"
                                     style      = {{backgroundImage: item.backgroundThumbnailImage}}
                                     onClick    = {() => {props.onCoverSelected(item)}}/>
                            )}
                        </div>
                    </div>
                )}
            </VScroll>
        </div>
    )
}
